const moment = require('moment')
export default {
	langFilter: value => {
		if (!value) {
			return ''
		} else {
			return value === 'cn' ? '中文' : '英文'
		}
	},
	templateFilter: value => {
		if (!value) return ''
		if (value.includes('white')) {
			return '经典工作模板'
		} else if (value.includes('stu')) {
			return '学生求职模板'
		} else if (value.includes('zero')) {
			return '零经验模板'
		} else if (value.includes('aboard_ba')) {
			return '留学申请模板'
		} else if (value.includes('bank')) {
			return '投行咨询模板'
		} else if (value.includes('product')) {
			return '产品经理模板'
		} else if (value.includes('programmer')) {
			return '程序员模板'
		} else if (value.includes('grad')) {
			return '申请研究生模板'
		}
	},
	timeFilter: (value, format) => {
		return moment(value).format(format)
	},
	timeFormatFilter: value => {
		let today = moment().format('YYYYMMDD')
		let update = moment(value).format('YYYYMMDD')
		let year = moment().year()
		let updateYear = moment(value).year()
		if (today === update) {
			return moment(value).format('HH:mm')
		} else if (update - 0 === today - 1) {
			return '昨天'
		} else if (update < today - 1 && year === updateYear) {
			return moment(value).format('MM月DD日')
		} else if (updateYear < year) {
			return moment(value).format('YYYY年MM月DD日')
		}
	}
	,
	dayTimeFilter: value => {
		if(!value){
			return ''
		}
		return moment(value).format('MM-DD HH:mm')
	}
}
